<div class="save-campaign-model p-(--padding-card)">
  <div class="field">
    <label for="modelName" class="block mb-(--space-2) font-semibold">
      {{ 'common.labels.modelName' | transloco }} <span class="text-red-500">*</span>
    </label>
    <input
      pInputText
      id="modelName"
      [ngModel]="modelName()"
      (ngModelChange)="onModelNameChange($event)"
      (blur)="onModelNameBlur()"
      class="w-full"
      [placeholder]="'common.placeholders.enterModelName' | transloco"
      [ngClass]="{
        'ng-invalid': hasNameError(),
        'ng-touched': true,
      }" />
    <div class="h-5 mt-(--space-1)">
      @if (hasNameError()) {
        <small class="text-red-500">{{ nameError() }}</small>
      }
    </div>
  </div>

  <div class="field mt-(--space-4)">
    <label for="modelDescription" class="block mb-(--space-2)"
      >{{ 'common.labels.description' | transloco }} ({{ 'common.labels.optional' | transloco }})</label
    >
    <textarea
      pInputText
      id="modelDescription"
      [ngModel]="modelDescription()"
      (ngModelChange)="modelDescription.set($event)"
      class="w-full"
      rows="3"
      [placeholder]="'common.placeholders.describeModel' | transloco"></textarea>
  </div>
</div>
